import { render, staticRenderFns } from "./DialogListTask.vue?vue&type=template&id=7b5e954a"
import script from "./DialogListTask.vue?vue&type=script&lang=js"
export * from "./DialogListTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b5e954a')) {
      api.createRecord('7b5e954a', component.options)
    } else {
      api.reload('7b5e954a', component.options)
    }
    module.hot.accept("./DialogListTask.vue?vue&type=template&id=7b5e954a", function () {
      api.rerender('7b5e954a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogListTask.vue"
export default component.exports